import React, { createContext, useContext, useState } from 'react'
import { useReturnToRouterListener } from 'utils/useReturnToPath'

let notificationId = 0

export interface Notification {
  id: number
  status?: 'default' | 'success' | 'error' | 'warning'
  icon?: React.ReactNode
  message: string
}

interface UiContextType {
  menuOpen: boolean
  setMenuOpen: (open: boolean) => void
  addNotification: (status: Notification['status'], message: Notification['message'], icon?: Notification['icon'], duration?: number) => void
  notifications: Notification[]
}

export const UiContext = createContext<UiContextType>({
  menuOpen: false,
  setMenuOpen: () => {},
  addNotification: () => {},
  notifications: []
})

interface Props {
  children: React.ReactNode
}
export const UiContextProvider = ({ children }: Props) => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false)
  const [notifications, setNotifications] = useState<Notification[]>([])
  useReturnToRouterListener()

  return (
    <UiContext.Provider
      value={{
        menuOpen,
        setMenuOpen: (open: boolean) => {
          setMenuOpen(open)
        },
        addNotification: (status = 'default', message, icon, duration = 2500) => {
          notificationId += 1
          const notification = { status, message, id: notificationId, icon }
          setNotifications((prev) => [...prev, notification])
          setTimeout(() => {
            setNotifications((prev) => prev.filter((item) => item.id !== notification.id))
          }, duration)
        },
        notifications
      }}>
      {children}
    </UiContext.Provider>
  )
}

export const useUiContext = (): UiContextType => {
  return useContext(UiContext)
}
